import { render, staticRenderFns } from "./TransitionFade.vue?vue&type=template&id=1011c28e&"
import script from "./TransitionFade.vue?vue&type=script&lang=js&"
export * from "./TransitionFade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports